<small class="debug">{{me}}</small>
<div style="position: relative; height: 100%;">
  <div class="pageWrapper" fxFlex="100%" fxLayout="column">
    <div style="display: flex">
      <mat-form-field class="form-element filterItem">
        <mat-label>by id</mat-label>
        <input matInput inputrestriction="basic1" type="text" (keyup)="applyFilter($event.target['value'], 'id')" name="SearchDualList" class="form-control" [(ngModel)]="globalFilterId" autocomplete="off"/>
        <a matSuffix aria-label="Clear" (click)="applyFilter(null, 'id')">
          <mat-icon>close</mat-icon>
        </a>
      </mat-form-field>
      <mat-form-field class="form-element filterItem">
        <mat-label>by class</mat-label>
        <input matInput inputrestriction="basic1" type="text" (keyup)="applyFilter($event.target['value'], 'class')" name="SearchDualList" class="form-control" [(ngModel)]="globalFilterClass" autocomplete="off"/>
        <a matSuffix aria-label="Clear" (click)="applyFilter(null, 'class')">
          <mat-icon>close</mat-icon>
        </a>
      </mat-form-field>
      <mat-form-field class="form-element filterItem">
        <mat-label>by func</mat-label>
        <input matInput inputrestriction="basic1" type="text" (keyup)="applyFilter($event.target['value'], 'func')" name="SearchDualList" class="form-control" [(ngModel)]="globalFilterFunc" autocomplete="off"/>
        <a matSuffix aria-label="Clear" (click)="applyFilter(null, 'func')">
          <mat-icon>close</mat-icon>
        </a>
      </mat-form-field>
      <mat-form-field class="form-element filterItem">
        <mat-label>by tag</mat-label>
        <input matInput inputrestriction="basic1" type="text" (keyup)="applyFilter($event.target['value'], 'tag')" name="SearchDualList" class="form-control" [(ngModel)]="globalFilterTag" autocomplete="off"/>
        <a matSuffix aria-label="Clear" (click)="applyFilter(null, 'tag')">
          <mat-icon>close</mat-icon>
        </a>
      </mat-form-field>
      <mat-form-field class="form-element filterItem">
        <mat-label>by arg</mat-label>
        <input matInput inputrestriction="basic1" type="text" (keyup)="applyFilter($event.target['value'], 'arg')" name="SearchDualList" class="form-control" [(ngModel)]="globalFilterArg" autocomplete="off"/>
        <a matSuffix aria-label="Clear" (click)="applyFilter(null,'arg')">
          <mat-icon>close</mat-icon>
        </a>
      </mat-form-field>
      <mat-form-field class="form-element filterItem">
        <mat-label>by msg</mat-label>
        <input matInput inputrestriction="basic1" type="text" (keyup)="applyFilter($event.target['value'],'msg')" name="SearchDualList" class="form-control" [(ngModel)]="globalFilterMsg" autocomplete="off"/>
        <a matSuffix aria-label="Clear" (click)="applyFilter('', 'msg')">
          <mat-icon>close</mat-icon>
        </a>
      </mat-form-field>
      <div style="padding-top: 10px">
        <button matTooltip="{{'general.refresh' | transloco}}" spinning (click)="loadStationLog()" mat-button>
          <mat-icon class="spinning">autorenew</mat-icon>
        </button>
        <button matTooltip="{{'general.refresh' | transloco}}" spinning (click)="clearStationLog()" mat-button>
          <mat-icon class="spinning">delete</mat-icon>
        </button>
      </div>
      <mat-label class="logMess">
        [ {{'general.logEnabledPerPlayer' | transloco}} ]
      </mat-label>
    </div>
    <div class="tableWrapper">
      <table mat-table [dataSource]="dataSource" multiple="false" matSort class="mat-elevation-z8">

        <ng-container matColumnDef="station_name">
          <th mat-header-cell [resizeColumn]="true" mat-sort-header *matHeaderCellDef>{{'general.name' | transloco}}</th>
          <td mat-cell *matCellDef="let element"> {{element.station_name}} </td>
        </ng-container>

        <ng-container matColumnDef="stationId">
          <th mat-header-cell [resizeColumn]="true" mat-sort-header *matHeaderCellDef>{{'general.id2' | transloco}}</th>
          <td mat-cell *matCellDef="let element"> {{element.stationId}} </td>
        </ng-container>

        <ng-container matColumnDef="time">
          <th mat-header-cell [resizeColumn]="true" mat-sort-header *matHeaderCellDef>{{'general.time' | transloco}}</th>
          <td mat-cell *matCellDef="let element"> {{element.time | StringJSV2Pipe:stringJSPipeEpoc}} </td>
        </ng-container>

        <ng-container matColumnDef="priority">
          <th mat-header-cell [resizeColumn]="true" mat-sort-header *matHeaderCellDef>{{'general.priority' | transloco}}</th>
          <td mat-cell *matCellDef="let element">
            @if (element.priority == '0') {
              <div>error</div>
            }
            @if (element.priority == '1') {
              <div>warning</div>
            }
            @if (element.priority == '2') {
              <div>info</div>
            }
            @if (element.priority == '3') {
              <div>debug</div>
            }
          </ng-container>

          <ng-container matColumnDef="tag">
            <th mat-header-cell [resizeColumn]="true" mat-sort-header *matHeaderCellDef>{{'general.tags' | transloco}}</th>
            <td mat-cell *matCellDef="let element"> {{element.tag}} </td>
          </ng-container>
          <ng-container matColumnDef="className">
            <th mat-header-cell [resizeColumn]="true" mat-sort-header *matHeaderCellDef>className</th>
            <td mat-cell *matCellDef="let element"> {{element.className}} </td>
          </ng-container>
          <ng-container matColumnDef="fncName">
            <th mat-header-cell [resizeColumn]="true" mat-sort-header *matHeaderCellDef>fncName</th>
            <td mat-cell *matCellDef="let element"> {{element.fncName}} </td>
          </ng-container>

          <ng-container matColumnDef="fncArgs">
            <th mat-header-cell [resizeColumn]="true" mat-sort-header *matHeaderCellDef>fncArgs</th>
            <td mat-cell *matCellDef="let element"> {{element.fncArgs}} </td>
          </ng-container>

          <ng-container matColumnDef="message">
            <th mat-header-cell [resizeColumn]="true" mat-sort-header *matHeaderCellDef>{{'general.message' | transloco}}</th>
            <td mat-cell *matCellDef="let element"> {{element.message}} </td>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <ng-container>
        <mat-paginator customPageSize
          [pageSize]="pageSize"
          [pageSizeOptions]="pageSizeOptions"
          [showFirstLastButtons]="true">
        </mat-paginator>
      </ng-container>
    </div>
  </div>




